export default "__VITE_ASSET__Bf2I9Cjq__"